<template>
  <el-dialog :title="title"
             :visible.sync="visible"
             :lock-scroll="true"
             width="818px"
             :before-close="handleClose">
    <div class="">
      <div style="padding: 24px 0;">
        <el-form ref="form"
                 :model="form"
                 :inline="false"
                 label-width="100px"
                 label-position="right"
                 style="text-align:left;">
          <el-form-item prop="posterName"
                        label="审核意见"
                        v-if="form.checkOpinion && form.checkStatus =='2' ">
            <el-input v-model.tirm="form.checkOpinion"
                      style="width: 300px;"
                      clearable
                      size="small"
                      disabled />
          </el-form-item>

          <el-form-item prop="posterName"
                        label="海报名称">
            <el-input v-model.tirm="form.posterName"
                      style="width: 300px;"
                      placeholder="请输入"
                      clearable
                      size="small"
                      disabled />
          </el-form-item>

          <el-form-item prop="posterCopyWriter"
                        label="发圈文案">
            <el-input v-model.tirm="form.posterCopyWriter"
                      type="textarea"
                      style="width: 300px;"
                      placeholder="请输入"
                      disabled
                      clearable
                      size="small" />
          </el-form-item>

          <el-form-item prop="imageUrl	"
                        label="海报内容">
            <!-- <imgUpload :limit="1" v-model="form.extendPlacard" :isEdit="true" style="position:relative;top:0px;">
              <template slot="tip">
                <p class="el-upload__tip">
                  备注:图片格式为jpg或png ,图片大小不得超过10M
                </p>
              </template>
            </imgUpload> -->
            <el-image v-for="(item,key) in form.extendPlacard"
                      style="width: 100px; height: 100px;margin-right:10px;"
                      :src="item"
                      :preview-src-list="form.extendPlacard"
                      :key="key">
            </el-image>
          </el-form-item>

          <section class="goods-list-warp">
            <div v-for="(item,key) in form.selectedData"
                 :key="key"
                 class="goods-list">
              <div style="display: flex;justify-content: flex-start;align-items: center;">
                <img :src="item.image || avater"
                     style="width: 80px;height: 80px;"
                     alt="">
                <div style="margin-left: 10px;">
                  <p style="margin: 3px 0;">{{ item.name }}</p>
                  <p style="margin: 3px 0;">{{ item.factory }}</p>
                  <p style="margin: 3px 0;">{{ item.specification }}</p>
                </div>
                <!-- <div>
                  <span>￥{{ item.lowestSalePrice }}~￥{{ item.highestSalePrice }}</span>
                </div> -->
              </div>
            </div>
          </section>

          <el-form-item>
            <el-button size="small"
                       type="success"
                       @click="pass()"
                       :disabled="isDisabled">审核通过</el-button>
            <el-button size="small"
                       type="primary"
                       @click="reject()"
                       :disabled="isDisabled">拒绝</el-button>
            <el-button size="small"
                       style="margin-left:12px"
                       @click="handleClose()">取消</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </el-dialog>
</template>
    
<script>

import { salesPosterInfoCheck, salesposterinfo } from "@/api/externalSalesRule";
import avater from "/public/img/default.png";
import imgUpload from '@/components/imgUpload';
export default {
  props: {},
  data () {
    return {
      avater: avater,
      disabled: false,
      id: '',
      pageType: '',
      isDisabled: false,
      form: {
        posterName: '',
        copywriting: '',
        extendType: '',
        sort: '',
        extendPlacard: [],
        selectedData: [],//选择的产品列表
      },
      options: [
        {
          value: 'SALESMAN',
          label: '业务员'
        },
        {
          value: 'CLIENT',
          label: '客户'
        },
      ],
      rules: {
        posterName: [{ required: true, message: '请填写通用名', trigger: 'blur' }],
      },
      title: '',
      visible: false,
    }
  },
  components: { imgUpload },
  created () { 
    this.id = this.$route.query.id || ''
    if (this.id) {
      this.query
    }
  },
  mounted () {

  },
  watch: {},
  methods: {

    reject () {
      this.handleClose();
      this.$emit('reject', this.form.id)
    },
    pass () {
      let params = {
        "id": this.form.id,
        "checkStatus": 1, //审核状态(0:待审核 1：审核通过 2：驳回) 
      }
      salesPosterInfoCheck(params).then((res) => {
        if (res) {
          this.$message.success('提交成功');
          this.$emit('getList')
          this.handleClose();
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    handleClose () {
      this.visible = false;
    },
    init (row, type) {
      this.title = '图文海报审核';
      if (type == 'detail') {
        this.isDisabled = true;
      } else {
        this.isDisabled = false;
      }
      console.log(row,'-row')
      this.form = row;
      this.form.extendPlacard = row.imageUrl.split(',');
      this.query(row.id);
      this.$forceUpdate();

    },
    query (id) {
      salesposterinfo(id).then(res => {
        this.form.selectedData = res.goodsBaseVOList;
        this.visible = true;
      })
    },
  }
}

</script>
<style lang="scss" scoped>
.eachRow {
  background-color: #fff;
  border-radius: 4px;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
}

.titleView {
  display: flex;
  align-items: center;

  .rowLine {
    width: 4px;
    border-color: 1px;
    background-color: var(--main-color);
    height: 16px;
    margin-right: 8px;
  }

  .eachRowTitle {
    font-size: 16px;
    color: #262626;
    font-weight: 600;
  }

  .cpxhead {
    display: flex;
    align-items: center;
  }

  .mark {
    color: #f56c6c;
    font-size: 12px;
    margin-left: 10px;
    width: 200px;
    line-height: 1.5;
    display: inline-block;
    font-weight: bold;
  }
}
.goods-list-warp {
  width: 100%;
  margin-left: 100px;
  max-height: 500px;
  overflow-y: auto;
}
.goods-list {
  width: 50%;
  border-bottom: solid 1px #f5f5f5;
  padding-bottom: 10px;
  &:nth-last-child(1) {
    border-bottom: none;
  }
}
</style>
  
  